module.exports = __webpack_public_path__ + "static/LGS-tablet-cc2b724ad9b38fb8c1f1617b0d2159b6.png";